import { Box, Typography } from "@mui/material";
import "./index.scss";

const LoginHeader = ({ step }) => {
  return (
    <Box className="login-header">
      <Typography variant="h5" component="h1" className="login-title">
        {step === "credentials" ? "Login to ATP Portal" : "Verify OTP"}
      </Typography>

      {step === "credentials" && (
        <span className="registered-badge">Registered partners only</span>
      )}
    </Box>
  );
};

export default LoginHeader;
